import { Transaction } from "../../features/auth/store/types/transaction-types";

type TransactionTableProps = {
  transactions: Transaction[];
  loading?: boolean;
};

const formatDate = (timestamp?: string) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

const formatTime = (timestamp?: string) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const Transable = ({
  transactions,
  loading = false,
}: TransactionTableProps) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!transactions || transactions.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 border border-[#FFFFFF1A] rounded-2xl">
        <div className="text-center">
          <p className="text-gray-500 dark:text-gray-400 text-lg mb-2">
            No transactions found
          </p>
          <p className="text-gray-400 dark:text-gray-500 text-sm">
            Try adjusting your search filters to see more results
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto">
        <table className="w-full border border-[#FFFFFF1A] rounded-2xl overflow-hidden">
          <thead>
            <tr className="bg-gray-100 dark:bg-[#FFFFFF1A] text-gray-600 dark:text-white uppercase text-xs bp:text-sm leading-normal h-[50px]">
              <th className="px-6 text-left">Tranc ID</th>
              <th className="px-6 text-left hidden sm:table-cell">
                Date & Time
              </th>
              <th className="px-6 text-left hidden sm:table-cell">Status</th>
              <th className="px-6 text-left">Type</th>
              <th className="px-6 text-left">Amount</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 dark:text-white text-xs bp:text-sm">
            {transactions.map((transaction) => (
              <tr
                key={transaction.id}
                className="border-b border-gray-200 h-[50px]"
              >
                <td className="px-6"> {transaction.id}</td>
                <td className="px-6 hidden sm:table-cell">
                  <div className="flex flex-col">
                    <span>{formatDate(transaction.created_at)}</span>
                    <span className="text-[11px] text-gray-500 dark:text-gray-400">
                      {formatTime(transaction.created_at)}
                    </span>
                  </div>
                </td>
                <td className="px-6 hidden sm:table-cell">
                  <StatusBadge
                    statusText={transaction.status_text || transaction.status}
                  />
                </td>
                <td className="px-6">
                  {transaction.type_text || transaction.type}
                </td>
                <td className="px-6 font-bold">{transaction.price ?? "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const StatusBadge = ({ statusText }: { statusText?: string }) => {
  const statusStyles: Record<string, string> = {
    PENDING: "text-orange-500",
    SUCCESS: "text-green-500",
    PAID: "text-green-500",
    REVERSED: "text-blue-500",
    FAILED: "text-red-500",
    QUEUED: "text-yellow-500",
  };

  return (
    <span
      className={`px-2 py-1 rounded text-sm font-medium ${
        statusText ? statusStyles[statusText] : "text-gray-500"
      }`}
    >
      {statusText || "Unknown"}
    </span>
  );
};
